import { render, staticRenderFns } from "./DocumentRevenue.vue?vue&type=template&id=1b93db3b&"
import script from "./DocumentRevenue.vue?vue&type=script&lang=js&"
export * from "./DocumentRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports